import { CDNPathUtil } from "../../../base/util/CDNPathUtil";
import { DefaultTheme } from "./DefaultTheme";
import { DarkTheme } from "./DarkTheme";
export class BgATheme {
}
BgATheme.theme = {
    saasAiAppTheme: {
        ...DefaultTheme.theme.saasAiAppTheme,
        background: `url(${CDNPathUtil.getFilePath("themeBgA.jpg")})`,
    },
    nodeTheme: {
        ...DefaultTheme.theme.nodeTheme,
    },
    appSignUpButtonTheme: {
        ...DefaultTheme.theme.appSignUpButtonTheme,
    },
    patchTheme: {
        nodeWrapperShadow: "0px 30px 60px 0px rgba(0, 0, 0, 0.15)",
        nodeBackdropFilter: DarkTheme.theme.nodeTheme.nodeBackdropFilter,
        renderingTransitionColors: "#ecf2fc",
    },
};
